import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { defaultEnvironmentConfig, EnvironmentConfig, EnvironmentConfigService } from '@stylehaven/components';

@Injectable({
    providedIn: 'root'
})
export class PortalConfigService extends EnvironmentConfigService {
    protected readonly FALLBACK_VALUE: EnvironmentConfig = defaultEnvironmentConfig;
    protected readonly TYPE_NAME: string = 'PortalConfig';

    constructor(protected http: HttpClient) {
        super(http);
    }

    protected override checkRequiresEnrichment(config: EnvironmentConfig): boolean {
        return super.checkRequiresEnrichment(config);
    }

    protected override createConfigEnrichment(config: EnvironmentConfig): Partial<EnvironmentConfig> {
        const baseUrl: string = window.location.host;

        return {
            baseUrl: config.baseUrl.replace(this.HOST_PLACEHOLDER, baseUrl),
            apiUrl: config.apiUrl.replace(this.HOST_PLACEHOLDER, baseUrl),
            registrationUrl: config.registrationUrl.replace(this.HOST_PLACEHOLDER, baseUrl),
            mh2Url: config.mh2Url.replace(this.HOST_PLACEHOLDER, baseUrl),
            embedUrl: config.embedUrl.replace(this.HOST_PLACEHOLDER, baseUrl),
            permalinkBase: config.permalinkBase.replace(this.HOST_PLACEHOLDER, baseUrl)
        };
    }
}
